import { IntlConfig, IntlError, IntlErrorCode } from 'next-intl';

export const onError = (error: IntlError) => {
  if (error.code === IntlErrorCode.MISSING_MESSAGE) {
    console.error(error);
  } else {
    // TODO: reportToErrorTracking(error);
  }
};

export const getMessageFallback: NonNullable<IntlConfig['getMessageFallback']> = ({
  namespace,
  key,
  error,
}) => {
  const path = [namespace, key].filter((part) => part != null).join('.');
  if (error.code === IntlErrorCode.MISSING_MESSAGE) {
    return path + ' is not yet translated';
  } else {
    return 'Dear developer, please fix this message: ' + path;
  }
};
